export default {
  ACCOUNT_STATEMENT: "Account statement",
  ACCOUNT_STATEMENTS: "Account statements",
  ACCOUNT_STATEMENTS_BALANCE: "Account statements closing balance",
  ACCOUNT_STATEMENTS_DATE: "Document date",
  ACCOUNT_STATEMENTS_MESSAGE: "Statements",
  ACCOUNT_STATEMENTS_NR: "Statement number",
  ACCOUNT_STATEMENTS_PAYMENT: "Account statements payment date",
  ACCOUNT_STATEMENTS_SEARCH: "Search by payment date",
  ACCOUNT_STATEMENTS_SERIAL: "Account statements serial number",
  ACTION: "ACTION",
  ADD_COMMENT: "Add a comment",
  ADD_ROW: "add row",
  ADMINISTRATION: "Administration",
  ADVANCED_SEARCH: "Advanched search",
  ALL: "All",
  ALREADY_DELIVERED: "Already delivered",
  AMOUNT: "Amount",
  AREA_STATEMENT: "Area Statement",
  AREA_STATEMENT_CREATE: "Enter area statement",
  AREA_STATEMENT_INFO: "View area statement",
  AREA_STATEMENT_MAKE: "Make Area Statement",
  AREA_STATEMENT_NO_SELECT_ERROR: "Select at least one area statement",
  AREA_STATEMENT_MORE_THAN_ONE_ERROR:
    "You can only create one area statement at a time. Make a new selection.",
  AREA_STATEMENT_SEARCH:
    "Search by counterparty, harvest year and gender of cultivar",
  AREA_STATEMENT_AVAILABLE: "No areaal sheet available ",
  AREA_STATEMENT_TITLE: "My Area Statement",
  ARTICLE: "Item",
  ARTICLE_DESCRIPTION: "Description",
  AUCTION: "Auction",
  BALANCE: "Opening Balance",
  BALANCE_MUTATION: "Balance changes",
  BALANCE_PREV: "Previous balance",
  BIO: "Bio",
  FYTOSANITAR: "Fytosanitair",
  BOTH: "Both",
  BROKEN_STORAGE_ALERT:
    "The column configurations have been updated to the default settings for this page. You must adjust the columns again if you have changed them. This is done via the 'Choose columns' button.",
  BUYER_COMPANY: "Original company name buyer",
  BUYER_COMPANY_NO_KV: "Original company name buyer",
  BUYER_NAME: "Buyer name",
  BUYER_NR: "Buyer number",
  BUYER_NR_REL: "Original customer number buyer",
  BUYER_REPS: "Representative buyer",
  CANCEL: "Cancel",
  CANCELED: "Canceled",
  CANNOT_UNDO: "You cannot undo this!",
  CHANGE_PASSWORD: "Change password",
  CHOOSE: "Choose",
  CHOOSE_COLUMN: "Choose columns",
  CLEAR: "To clear",
  CLIENT_NAME: "Customer name",
  CLIENT_NR: "Customer number",
  CLOSED: "Closed",
  CLOSING_BALANCE: "Closing balance",
  CNB_DESCRIPTION:
    "Mediation in flower bulbs, tubers and perennials since 1919",
  COMPANY_DETAILS: "Company details",
  COMPANY_INFORMATION_EDIT: "Edit information",
  COMPANY_FINANCIAL: "Financial information",
  COMPANY_INFORMATION: "Company Information",
  COMPANY_NAME: "Company name",
  COMPANY_OTHER_DETAILS: "Other details",
  COMPANY_LEGAL_PERSON: "Legal person",
  COMPANY_KVK_NUMBER: "Chamber of Commerce number",
  COMPANY_PHONE: "Phone number",
  COMPANY_EMAIL: "Email address",
  COMPANY_EMAIL_TOOLTIP:
    "This e-mail address is shown on all your documents, such as invoices, orders and account statements. This e-mail address is not related to the CNB newsletter.",
  COMPANY_PHONE_TOOLTIP:
    "This phone number is shown on all your documents, such as orders and invoices. If you want to change other telephone numbers, you must contact the administration department via administratie@cnb.nl.",
  COMPANY_CNB_MEMBERSHIP_TOOLTIP:
    "If you want to become a member of CNB please contact our administration department",
  COMPANY_CORRESPONDENCE_ADDRESS: "Correspondence address",
  COMPANY_CORRESPONDENCE_POSTCODE: "Correspondence postcode",
  COMPANY_CORRESPONDENCE_PLACE: "Correspondence place",
  COMPANY_CORRESPONDENCE_COUNTRY: "Correspondence country",
  COMPANY_BUSINESS_ADDRESS: "Business address",
  COMPANY_BRANCH_POSTCODE: "Branch postcode",
  COMPANY_LOCATION: "Location",
  COMPANY_COUNTRY: "Country",
  COMPANY_DELIVERY_ADDRESS: "Delivery address",
  COMPANY_DELIVERY_POSTCODE: "Delivery postcode",
  COMPANY_DELIVERY_PLACE: "Delivery place",
  COMPANY_DELIVERY_COUNTRY: "Delivery country",
  COMPANY_IBAN: "IBAN",
  COMPANY_SWIFT: "SWIFT-code",
  COMPANY_BTW: "BTW status",
  COMPANY_EXPORTER: "Exporter",
  COMPANY_BTW_NUMBER: "BTW-number",
  COMPANY_BKD_NUMBER: "BKD-number",
  COMPANY_NAKT_NUMBER: "NAKT number",
  COMPANY_PHYTO_NUMBER: "Phytosanitary number",
  COMPANY_SUSTAINABILITY_CERTIFICATE: "Sustainability certificate",
  COMPANY_CNB_LID: "CNB lid",
  COMPANY_CNB_MEMBER_FORM: "CNB member from",
  COMPANY_EDI_CODE: "EDI code/GLN code",
  COMPANY_DIGITAL: "Doing business digitally",
  COMPANY_DIGITAL_TOOLTIP:
    "If you do business digitally with CNB you will receive your documents via My CNB, orders are also sent by e-mail. We advise our customers to do business digitally, because this is time-saving and efficient, with everything archived in one place.",
  COMPANY_UPDATE_MESSAGE: "Your changes have been recorded",
  COMPANY_UPDATE_ERROR_MESSAGE:
    "Oops. Something went wrong. Please try again later. If it does not work, you can contact us at info@cnb.nl",
  COMPANY_CERTIFICATE_PARTICIPATION: "Participation",
  COMPANY_CERTIFICATE_REGISTRATION: "Registration Number",
  COMPANY_CERTIFICATE_ORGANISATION: "Certification Organization",
  COMMENT: "Remark",
  CONFIRM_CONTINUE: "Do you want to continue?",
  CONTACT: "Contact us",
  CONTACT_CNB: "Response form",
  CONTACT_FILES: "Attachment",
  CONTACT_SUBJECT: "Subject",
  CONTACT_TEXT: "Remark",
  CONTACT_USER: "Username",
  COST: "Cost",
  COUNTERPARTY: "Counterparty",
  COUNTERPARTY_COMPANY: "Company name seller",
  COUNTERPARTY_NAME: "Counterparty name",
  COUNTERPARTY_NAME_REL: "Counterparty name",
  COUNTERPARTY_NR: "Counterparty Nr.",
  COUNTERPARTY_NR_REL: "Counterparty number",
  COUNTERPARTY_NUMBER: "Counterparty number",
  COUNTERPARTY_VAT: "VAT status counterparty",
  CULTIVAR: "Cultivar",
  CULTIVATION_ADVICES: "Cultivation advice",
  CULTIVATION_ADVICES_ADD: "Add cultivation advice",
  CULTIVATION_ADVICES_EDIT: "Edit page",
  CULTIVATION_ADVICES_HEADER: "My cultivation advices",
  CULTIVATION_ADVICES_PDF: "Pdf",
  CULTIVATION_ADVICES_IMG: "Photo",
  CULTIVATION_ADVICES_MSG: "Messages cultivation advice",
  CULTIVATION_ADVICES_SEARCH: "Search by Title",
  CULTIVATION_LOCATIONS:
    "Cultivation locations-Growing places: Address (Residential) place",
  CURRENT_DATE: "Current date",
  CUSTOMER_CHANGE: "Select another customer",
  CUSTOMER_NAME: "Customer name",
  CUSTOMER_SEARCH: "Search by customer name and number",
  DASHBOARD: "Dashboard",
  DATE: "Date",
  DATE_LABEL: "to",
  DAYS: "days",
  DEDUCTIONS_BLOCKAGES: "Deductions and blockages",
  DELIVERIED_BY: "Delivered by",
  DELIVERIED_QUANTITY: "Quantity delivered",
  DELIVERIED_TO: "Delivered to",
  DELIVERIES: "Deliveries",
  DELIVERIES_ADD_LINE: "Add line",
  DELIVERIES_ADDRESS: "Alternative delivery address",
  DELIVERIES_ADDRESS_HEADER: "Delivery address",
  DELIVERIES_AM: "AM-Status",
  DELIVERIES_AM_TYPE: "AM-Status",
  DELIVERIES_BATCH: "Batch",
  DELIVERIES_BIO: "Biologically grown",
  DELIVERIES_BKD: "BKD Certificate",
  DELIVERIES_BUYER: "Buyer name",
  DELIVERIES_BUYER_NR: "Customer number of buyer",
  DELIVERIES_CARRIER: "Transporter",
  DELIVERIES_CERTIFICATE: "Certificate type",
  DELIVERIES_CHECK: "To check",
  DELIVERIES_CITY: "Shipped from",
  DELIVERIES_CLASS: "Class",
  DELIVERIES_COMMENT: "Remark for delivery note",
  DELIVERIES_COMMENT_SUPPLIER: "Remark supplier",
  DELIVERIES_COMMENT_TRANSPORT: "Transport remark",
  DELIVERIES_COMMENTS: "Comments",
  DELIVERIES_COMPLETE: "Completely delivered",
  DELIVERIES_COPY_LINE: "Copy this line as new",
  DELIVERIES_CREATE: "Create delivery note",
  DELIVERIES_CULTIVAR: "Cultivar",
  DELIVERIES_DATE: "Date of delivery",
  DELIVERIES_DETAILS: "Delivery details",
  DELIVERIES_DOWNLOAD: "Download deliveries",
  DELIVERIES_END_DATE: "Delivery date",
  DELIVERIES_EXTRA_COST: "Extra cost",
  DELIVERIES_FOR: "Order number",
  DELIVERIES_FRANCO: "Freight paid",
  DELIVERIES_FUST: "#Container",
  DELIVERIES_FUST_BUYER: "Buyer's container",
  DELIVERIES_FUST_HEADER: "Container",
  DELIVERIES_FUST_LINES: "Fust lines",
  DELIVERIES_FUST_SELLER: "Seller's container",
  DELIVERIES_FUST_THIRD_PARTY: "Third party's container",
  DELIVERIES_GENUS: "Genus",
  DELIVERIES_HEADER: "Deliveries",
  DELIVERIES_LINES: "Delivery note lines",
  DELIVERIES_MINIMUM_ONE_ORDER: "Select at least 1 order line",
  DELIVERIES_NA: "N/A",
  DELIVERIES_NOT_FRANCO: "Freight not paid",
  DELIVERIES_NOTE:
    "This comment is not read by CNB, it is printed on the delivery note",
  DELIVERIES_NR: "Number",
  DELIVERIES_ONLY_ONE_BUYER:
    "You can only deliver for one buyer. Make a new selection",
  DELIVERIES_PART: "Part delivery",
  DELIVERIES_PER_FUST: "#Per container",
  DELIVERIES_PLANNED_DATE: "Scheduled delvivery date",
  DELIVERIES_POSTAGE: "Postage",
  DELIVERIES_PRICE_ONE: "Price/piece",
  DELIVERIES_PRICE_PER_ONE: "Price per piece",
  DELIVERIES_QUANTITY: "Quantity on order",
  DELIVERIES_REMOVE_LINE: "Remove this line",
  DELIVERIES_REPORT: "Send delivery report",
  DELIVERIES_REQUIREMENTS: "Postage requirements",
  DELIVERIES_REST: "Rest delivery",
  DELIVERIES_REST_FUST: "#Container remaining",
  DELIVERIES_SEARCH:
    "Search by number, order number, counterparty's name and description",
  DELIVERIES_SEND_AND_PRINT: "Send and print delivery note",
  DELIVERIES_SOLD: "Amount sold",
  DELIVERIES_STATUS_AM: "AM-free",
  DELIVERIES_STATUS_NOT_AM: "Not-AM-free",
  DELIVERIES_STEPS: "Step {currentStep}/6 Delivery",
  DELIVERIES_TILL_DATE: "Delivery date till",
  DELIVERIES_TOTAL: "#Total",
  DELIVERIES_TRANSFER: "Transfer",
  DELIVERIES_TRANSPORT: "Transport",
  DELIVERIES_TRANSPORTER: "Transporter",
  DELIVERIES_TYPE: "Batch",
  DELIVERIES_WHOLE: "Entire delivery",
  DELIVERY: "Shipment",
  DESCRIPTION: "Description",
  DIFFERENT_HARVEST: "The selected order lines have a different harvest year",
  DIRECT: "Directly",
  DOCUMENT_DATE: "Document date",
  DOCUMENT_TYPE_CONTRACT: "Contract cultivation",
  DOCUMENT_TYPE_LEASE: "Rent",
  DOCUMENT_TYPE_MEDIATION: "Mediation",
  DOCUMENT_TYPE_PORTION: "Portion",
  DOCUMENT_TYPE_RENT: "Leasehold",
  DOWNLOAD_LOADING: "Download is being prepared...",
  EDIT_COMMENT: "edit comment",
  EMAIL_AUTHOR: "CNB administration",
  EMAIL_ERROR: "Couldn't send message to administrator, please try later.",
  EMAIL_GREETINGS: "Dear customer",
  EMAIL_PHONE: "Phone",
  EMAIL_REGARDS: "Kind regards",
  EMAIL_TEXT:
    "Thank you for completing the form on Mijn CNB. \nWe will respond to your question within 24 hours.",
  EMAIL_TITLE: "My CNB: Contact form",
  ENTER_DELIVERIES: "Enter deliveries",
  EXCEL_INFO:
    "It exports to Excel all lines that are found via the search filter and has nothing to do with selecting lines",
  EXTERNAL_DOCUMENT: "External number",
  EXTERNAL_NR: "External document",
  FAQ: "Frequently Asked Questions",
  FIXED: "Fixed",
  FROM: "from",
  GREENHOUSE: "Greenhouse",
  GREENHOUSE_OR_LAB: "Greenhouse / Laboratory",
  GROWER: "Growers association",
  GROWER_COMPANY: "Growers association",
  GROWER_NAME: "Growers association",
  GROWER_NR: "Growers association Nr.",
  HARVEST_YEAR: "Harvest year",
  IMPORTANT: "Important",
  INPUT_FILE_CHOOSE: "Choose file",
  INPUT_FILE_NO: "No file chosen",
  INPUT_FILE_SELECTED: "File selected",
  INSPECTION_DATE: "Entry date",
  INSPECTION_NR: "Report number",
  INSPECTION_REPORT: "Inspection reports K&P",
  INSPECTION_SEARCH: "Search by batch number and supplier's name",
  INSPECTION_TYPE: "Confirmation type",
  INTERNAL_CULTIVATION_ADVICE: "Invoer bericht teeltadvies",
  INTERNAL_MANAGE: "Beheer intern",
  INTERNAL_NOTIFICATIONS: "Invoer meldingen",
  INVOICE: "Invoice",
  INVOICES: "Invoices",
  INVOICES_AMOUNT: "Invoice amount",
  INVOICES_AMOUNT_VAT: "Invoice amount (incl. VAT)",
  INVOICES_BALANCE: "Invoice balance",
  INVOICES_BTW: "VAT%",
  INVOICES_BTW_AMOUNT: "VAT amount on commission",
  INVOICES_BTW_GROSS: "VAT gross amount",
  INVOICES_BTW_RATE: "VAT rate on commission",
  INVOICES_COMMENT: "Remarks",
  INVOICES_COMMISSION: "Commission",
  INVOICES_COMMISSION_AMOUNT: "Commission amount",
  INVOICES_COMMISSION_PERCENT: "Commission rate",
  INVOICES_COMMISSION_SALE:
    "Sale Commission {range} ({percentOne}% or {percentTwo}%)",
  INVOICES_DATE: "Invoice date",
  INVOICES_DELIVERY: "Delivery note/Receipt/Retun note",
  INVOICES_DESCRIPTION: "Invoice description",
  INVOICES_DETAILS: "Invoice details",
  INVOICES_DOWNLOAD: "Download invoice",
  INVOICES_EX_BTW: "Amount (excl. VAT)",
  INVOICES_GROSS: "Gross amount",
  INVOICES_INCL_BTW: "Amount invoice line incl VAT",
  INVOICES_INCL_BTW_RANGE:
    "Purchase Commission {range} ({percentOne}% or {percentTwo}%)",
  INVOICES_KIND: "Invoice type",
  INVOICES_LINES: "Invoice lines",
  INVOICES_MANUAL: "Manual invoice",
  INVOICES_NUMBER: "Invoice number",
  INVOICES_NR: "Invoice nr.",
  INVOICES_PAID: "Paid invoice amount",
  INVOICES_RECENT: "Recent invoices",
  INVOICES_REST: "Remaining invoice amount",
  INVOICES_SEARCH: "Search by invoice number, counterparty and description",
  INVOICES_TOTAL: "Total invoice amount",
  INVOICES_TOTAL_INCL_VAT: "Total invoice amount incl. VAT",
  INVOICES_TOTAL_INCL_VAT_RANGE:
    "Total invoice amount incl. VAT {range} ({percentOne}% or {percentTwo}%)",
  INVOICES_TYPE: "Invoice type",
  INVOICES_VIEW_ALL: "view all invoices",
  IVB: "IVB",
  KPB: "K&P",
  LAB_NAME: "Laboratory Name",
  LINE_NR: "Line",
  LINE_NUMBER: "Line number",
  LOADING: "Loading...",
  LOG_OUT: "Log out",
  LICENSOR_NUMBER: "Licensor Number",
  LIVERBAR_NOTE_ZANT:
    "Surface area of basic material for liverbar tubers cultivation",
  KIND: "Kind",
  MAKE_CHOICE: "Make a choice",
  MARK_AS_READ: "Mark as read",
  MARK_AS_UNREAD: "Mark as unread",
  MARK_FULLY_DELIVERED: "There will be no (additional) delivery",
  MAXIMUM_ONE_BUYER:
    "You can not select more than 1 buyer. Make a new selection",
  MESSAGE_RECEIPT_AND_RETURN: "ReceiptAndReturn",
  MESSAGE_RECEPTION: "Reception",
  MESSAGE_REPORT: "Inspection report",
  MESSAGE_SENT: "Your message has been sent. We will contact you",
  MINIMUM_ONE_ORDER: "Select at least 1 order line",
  MINUS_SIGN: "-",
  MULTIPLE_ADDRESSES:
    "The selected order lines have multiple delivery addresses. If you choose to continue, the first delivery address will be used for the total delivery",
  MY_DELIVERIES: "My deliveries",
  MY_DELIVERIES_SEARCH:
    "Search by buyer's name, order number, planned delibery date and description",
  MY_REPORTS: "My reports",
  NAME: "Name",
  NEW: "New",
  NEWSLETTER: "Newsletter",
  NEXT_STEP: "Next step",
  NO: "No",
  NO_AVAILABLE: "Document not available",
  NO_DATA: "There is no data",
  NO_DATA_EXPORT: "There is no data to export",
  NO_DOCUMENT: "Document does not exist",
  NO_FILE: "There is no file to download",
  NO_SHIPPING_ID: "Entity does not exist",
  NOT_COMPLETELY_FILLED: "is not completely filled",
  NOT_DELIVERED: "Still to be delivered",
  NOT_PUBLISHED: "Not published",
  NOTIFICATIONS: "Notifications",
  NOTIFICATIONS_ADD: "Add notifications",
  NOTIFICATIONS_EDIT: "Edit notifications",
  NOTIFICATIONS_DATE: "Datum plaatsing",
  NOTIFICATIONS_END_DATE: "Einddatum",
  NOTIFICATIONS_FILES: "Files",
  NOTIFICATIONS_NO_DATA: "There are no new notifications at this time.",
  NOTIFICATIONS_SEARCH: "Search by Title",
  NOTIFICATIONS_VIEW_ALL: "view all notifications",
  NUMBER: "Number",
  OLD_HARVEST: "The selected order lines have an old harvest year",
  OPEN: "Open",
  OPEN_PDF: "Open PDF",
  ORDER: "Order",
  ORDERS: "Orders",
  ORDERS_AMOUNT: "Order amount",
  ORDERS_AMOUNT_EX_BTW: "Order amount (excl. VAT)",
  ORDERS_BUYER_REP: "Repr. buyer",
  ORDERS_COVER: "Cover",
  ORDERS_DATE: "Order date",
  ORDERS_DELIVERY_ADDRESS: "Delivery address",
  ORDERS_DETAILS: "Order details",
  ORDERS_DOWNLOAD: "Download order",
  ORDERS_EX_BTW: "Amount (excl. VAT)",
  ORDERS_FROM_DATE: "From delivery date",
  ORDERS_LAST_DATE: "Last version date",
  ORDERS_LINE_NR: "Line number",
  ORDERS_LINES: "Orderlines",
  ORDERS_NUMBER: "Order number",
  ORDERS_NR: "Order nr.",
  ORDERS_PAYMENT: "Advance payment",
  ORDERS_RATE: "Rate/provision",
  ORDERS_RECEIPTS: "Receipts/returns",
  ORDERS_RECENT: "Recent orders",
  ORDERS_REF: "Ref. number",
  ORDERS_SCHEME: "Cover scheme",
  ORDERS_SEARCH:
    "Search by order number, counterparty, harvest year and description",
  ORDERS_SELLER_REP: "Repr. seller",
  ORDERS_SKAL: "Skal number",
  ORDERS_STATE: "Order cancelled",
  ORDERS_TYPE: "Type of order",
  ORDERS_VERSION_DATE: "Version date",
  ORDERS_VIEW_ALL: "view all orders",
  OTHER: "Other",
  OTHER_PARTY_NAME: "Counterparty Name",
  OTHER_PARTY_NUMBER: "Counterparty Number",
  PAID_AMOUNT: "Paid amount",
  PAYMENT_DATE: "Payment date",
  PDF_DOWNLOAD: "Download the PDF.",
  PDF_NOT_SUPPORT: "Your browser does not support PDFs.",
  PLANTING_MATERIAL_SOLD: "Planting material sold last harvest year",
  PLANTING_MATERIAL_NOTE_ZANT:
    "Surface material for planting material (fine parting, 'chopping', bread machine, etc.)",
  PLUS_SIGN: "+",
  PORTIONS: "Number of Portions",
  PREFERRED_GROWER: "Preferred grower",
  PREFERRED_GROWER_COMPANY: "Preferred grower number",
  PREFERRED_GROWER_NAME: "Preferred grower",
  PREFERRED_GROWER_NR: "Preferred grower Nr.",
  PREFERRED_GROWER_NR_REL: "Preferred grower number",
  PREFERENCES: "Preferences",
  PREFERENCES_CARRIER_REMARKS: "Standard Carrier remarks",
  PREFERENCES_COMMENT: "Standard comment",
  PREFERENCES_CONTAINER: "Container standard",
  PREFERENCES_FUST_REMARKS: "Standard Fust remarks",
  PREFERENCES_HARVEST_YEAR: "Standard harvest year",
  PREFERENCES_INVOICE_NOTE: "Standard invoice note",
  PREFERENCES_LILY_DELIVERY: "Lily delivery standard",
  PREFERENCES_LILY_ST: "Create lily standard",
  PREFERENCES_LINE: "In line #{number}",
  PREFERENCES_LOGO: "Print CNB Logo on delivery note",
  PREFERENCES_OTHERS_DELIVERY: "Others delivery standard",
  PREFERENCES_PACKAGE: "At 'own packaging'",
  PREFERENCES_TO_DELIVER: "To deliver",
  PREFERENCES_TULIP_DELIVERY: "Tulips deliver standard",
  PREVIOUS: "Previous",
  PRICE: "Price",
  PRICE_UNIT: "Price unit",
  PRINT_NOTE: "Print delivery note?",
  PRODUCT_GROUP: "Product group",
  PUBLISHED: "Published",
  PURCHASE_TYPE: "Purchase type",
  QUALITY_PLUS: "Quality plus",
  QUANTITY: "Quantity",
  QUANTITY_KG: "Quantity Kg",
  QUANTITY_UNIT: "Quantity unit",
  READ_MORE: "Read more",
  REASON: "Reason",
  RECEIPT_CONFIRMATION: "Receipt",
  RECEIPTS_AND_RETURNS: "Receipts and returns",
  RECEIPTS_AND_RETURNS_HEADER: "Receipts / returns",
  RECEIPTS_AND_RETURNS_MSG: "Receipts and returns",
  RECEIPTS_NR: "Batch number",
  RECEIPTS_DATE: "Receiving date",
  RECEIPTS_REPORT: "Receipt reports K&P",
  RECEIPTS_SEARCH: "Search by number, counterparty's name and order number",
  RECEIPTS_SUPPLIER: "Supplier name",
  RECONFIRMATION: "Reconfirmation",
  RELATION: "Counterparty number",
  RELATION_NR: "Relation number",
  REMAINING: "Remaining",
  REMOVE: "Remove",
  REMOVE_COMMENT: "Remove comment",
  REPORT_APPROVAL: "Intake inspection",
  REPORTS_AREA_STATEMENT: "Submitted area statement",
  REPORTS_INVOICED_AREA_STATEMENT_OVERVIEW:
    "Overview of invoiced Area Statements",
  REPORT_INSPECTION: "Reinspection",
  REPORTS: "Reports",
  REPORTS_DELIVERED: "Current stock K&P",
  REPORTS_EXCEL: "Export to Excel",
  REPORTS_ICP: "I.C.P. overview",
  REPORTS_INFO:
    "Current stock of lilies packed by CNB.\nOnly to be used during the packing season.",
  REPORTS_INVOICED_DELIVERY: "Invoiced deliveries",
  REPORTS_INVOICED_DELIVERY_OVERVIEW: "Overview of invoiced deliveries",
  REPORTS_NR: "Batch number",
  REPORTS_PDF: "Open as .PDF",
  REPORTS_READY: "Inspection reports K&P",
  REPORTS_SEARCH: "Search by number, description and supplier's name",
  REPORTS_SHOW_ICP: "Show I.C.P. overview",
  REPORTS_SHOW_VAT: "Show VAT and turnover overview",
  REPORTS_TYPE: "Type of inspection",
  REPORTS_TULIPS: "G-stage tulips K&P",
  REPORTS_VAT: "VAT and turnover overview",
  RESET: "Reset",
  RESIDENCE: "Residence",
  RESULT: "Result",
  ROLE_GROWER: "Grower",
  ROLE_PURCHASE: "Buying",
  ROLE_SALE: "Selling",
  ROYALTIES: "Royalties",
  RR: "RR",
  SAME_BIO:
    "You can not combine rules of organically grown products and non-organically grown products on a single invoice. Make a new selection",
  SAVE: "Save",
  SAVE_CHANGES: "Save changes",
  SEARCH: "Search",
  SELECTED: "With selected",
  SELECTED_FILTERS: "Selected filters:",
  SELLER_NAME: "Seller Name",
  SELLER_COMPANY: "Representative seller",
  SERIAL_NR: "Reference number",
  SERVICE: "Service",
  SERVICE_SUPPORT: "Service & support",
  SERVICE_AND_SUPPORT: "Service and support",
  SETTINGS: "Account settings",
  SETTINGS_DOCUMENTS:
    "Documents and advices for which you want to receive notifications:",
  SETTINGS_PASSWORD: "To change password, click the button below.",
  SETTINGS_SAVED: "Settings saved",
  SHOW: "Show",
  SHOW_LESS: "show less",
  SHOW_MORE: "show more",
  SHOW_UNREAD: "Show only unread",
  SIZE: "Size",
  SIZE_NR: "Size {number}",
  STATUS: "Status",
  SUBMIT: "Submit",
  SUBSCRIPTION: "Subscription",
  SUCCESS: "Successfully done!",
  SUPPORT: "Support",
  SUPPORT_ANSWER_ACCESS: `Let op dit kan alleen door de hoofdgebruiker uitgevoerd worden!\nU kunt iemand anders binnen/buiten uw bedrijf, bijv. uw collega of uw boekhouder, toegang geven tot uw (deel)gegevens. U kunt een aanvraag doen via “Gebruikersbeheer” door rechtsboven op uw inlognaam te klikken. Daarna klikt u in het drop down menu op “Gebruikersbeheer”. U ziet dan alle huidige gebruikers. Hier kunt u een nieuwe gebruiker toevoegen en aangegeven wat hij/zij mag zien.\nU klikt op het “+” teken om een gebruiker toe te voegen. U komt dan in een nieuw scherm.\nU geeft naam (dit is ook uw inlognaam) en e-mail adres op en geeft aan in welke taal hij/zij het portaal gaat gebruiken. Omdat uw naam ook uw inlognaam is mogen hier geen spaties in staan. Wij adviseren dan ook hier uw e-mail adres op te geven.\n{imageOne}\nVervolgens geeft u aan welke notificatie hij of zijn mag/moet ontvangen. Dit zijn de e-mail berichten die u ontvangt zodra er een nieuw document beschikbaar is.\nVervolgens klikt u op “opslaan”.\nNadat u heeft opgeslagen is uw account aangemaakt, maar nog niet klaar!\nVervolgens krijgt onderstaand scherm te zien:\n{imageTwo}\nU moet hier uw account nog koppelen aan een klant door nogmaals op het “+” te klikken.\nU krijgt dan onderstaand scherm te zien:\n{imageThree}\nU ziet de gebruikersnaam die u zojuist heeft ingevoerd. Vervolgens klikt u ‘Klant’ aan als u toegang wilt geven tot uw bedrijfsgegevens. Mocht u beheerder zijn voor meerdere bedrijven dan dient u dit proces meerdere keren te doorlopen als deze persoon daar ook toegang toe moet hebben.\nVervolgens geeft u in “Modules” aan tot welke modules deze persoon toegang moet krijgen. Module ‘Algemeen’ dient u altijd aan te vinken!\nVervolgens klikt u op “Opslaan”. De nieuwe gebruiker krijgt nu een mail om de aanvraag te bevestigen.`,
  SUPPORT_ANSWER_ADDRESS:
    "U kunt zelf niets wijzigen. Wijzigingen in uw NAW gegevens kunt u mailen naar administratie@cnb.nl",
  SUPPORT_ANSWER_ALL_DELIVERIES:
    "U kunt dit instellen via de voorkeursinstellingen bij de invoer van leveringen. U vindt een uitgebreide instructie in de handleiding invoeren leveringen. Deze handleiding kunt u vinden onder klantenservice bij Mijn CNB. ",
  SUPPORT_ANSWER_ARRIVED:
    "Er is geen terugkoppeling op het klantportaal over de ontvangst van de leveringsnota door het ketenregister. U kunt voor informatie contact opnemen met de BKD.",
  SUPPORT_ANSWER_BATCH_DATA:
    "Het ketenregister registreert de partijgegevens bij de koper van uw bollen. De koper heeft alleen inzicht in de gegevens die bij de afgeleverde partij horen. Meer informatie kunt u vinden op {link}",
  SUPPORT_ANSWER_CHAIN_REGISTER:
    "Dit is een digitale verbinding tussen het teeltregister van de BKD en Client export in overleg met de NVWA (Nederlandse Voedsel- en WarenAutoriteit). U kunt meer informatie over het ketenregister vinden op {link}",
  SUPPORT_ANSWER_CHANGE_PASSWORD:
    "Uw wachtwoord blijft altijd geldig. Wij adviseren u wel periodiek uw wachtwoord te veranderen.",
  SUPPORT_ANSWER_CNB:
    "Als u uw partijgegevens meldt aan het ketenregister via Mijn CNB dan worden deze ook door CNB verwerkt. U hoeft de levering dan niet meer apart aan CNB te melden.",
  SUPPORT_ANSWER_CORRECTION:
    "U kunt correcties in de partijgegevens aan het ketenregister melden via het digitaal klantenloket van de BKD.",
  SUPPORT_ANSWER_DELIVERIES:
    "Ga naar het menu onderdeel Administratie ‘Leveringen invoeren’. U ziet in het scherm alle nog niet (volledig) geleverde orderregels. Vink de orderregels aan waarvoor u een levering wilt maken en klik op ‘Leveringsnota maken’.\nZie handleiding “leveringen invoeren” voor meer informatie.",
  SUPPORT_ANSWER_DONT:
    "De partijgegevens van de leveringsnota worden niet naar het ketenregister gestuurd, tenzij u dit zelf aangeeft bij de invoer van de leveringsnota.",
  SUPPORT_ANSWER_GROWER:
    "Ga naar het menu onderdeel Administratie ‘Leveringen invoeren’. Klik op ‘Uitgebreid zoeken’ en klik het vinkje aan bij ‘Kooptype’. Daarna klikt u op ‘Kweker’. U ziet nu alle orders waarbij u de voorkeurkweker bent van een kwekersvereniging.",
  SUPPORT_ANSWER_ORDERS: `Klik op 'Uitgebreid zoeken'\n{imageOne}\nU ziet nu een zoekveld waarbij u zelf kunt aangegeven wat u wilt zoeken.\nAls u bijv. alle orders wilt zoeken van een bepaalde wederpartij dan vult u daar de naam in en alle orders die gemaakt zijn tussen u en de wederpartij verschijnen dan in het scherm. U kunt ook nog uitgebreider zoeken door op ‘Toon meer’ te klikken. Dan klapt het scherm verder open voor nog meer zoek mogelijkheden.\n{imageTwo}`,
  SUPPORT_ANSWER_OTHER:
    "U kunt geen partijgegevens van de koopovereenkomst/orders van andere IVB’s aan het ketenregister melden via Mijn CNB. U kunt dit wel rechtstreeks bij de BKD doen via het Digitaal Klanten Loket (DKL) van de BKD.",
  SUPPORT_ANSWER_PASSWORD: `Klik onder het kopje “Overige” op “Persoonlijke instellingen”. Onderaan het scherm klikt u op “Wachtwoord wijzigen” Dan verschijnt onderstaand scherm.\n{imageOne}\nU vult hier uw gebruikersnaam in en klikt op ‘Mailbericht verzenden’. U ontvangt een mail met een link om uw wachtwoord te wijzigen.\nU ziet dan onderstaand scherm\n{imageTwo}\nHier geeft u 2x hetzelfde “nieuwe” wachtwoord in en klikt op ‘Instellen’. Let op dit wachtwoord moet minimaal 8 tekens bevatten, waaronder een hoofdletter, een getal en een leesteken.`,
  SUPPORT_ANSWER_REPORT:
    "U moet voor het afleveren van de bollen de partijgegevens melden aan het ketenregister. Dit kunt u op een eenvoudige manier doen bij het maken van de leveringsnota.",
  SUPPORT_ANSWER_SEARCH: `U kunt onder ‘Facturen’ klikken op Uitgebreid zoeken. Dan ziet u een zoekveld (als u op ‘Toon meer’ klikt zie u nog meer zoekvelden) waarbij u op bijv. één ordernummer alle facturen kunt terugvinden.\nTik het ordernummer in en klik dan op Zoeken\n{image}\nVervolgens kunt u alle facturen bekijken door op het pdf pictogram te klikken dat voor het factuurnummer staat.`,
  SUPPORT_ANSWER_SEEN: `U kunt alle ongelezen documenten apart inzien onder bijv. orders, facturen en rekeningoverzichten.\nU klikt aan waarvan u de ongelezen documenten wilt inzien. Bijv. Orders.\nU klikt op Orders. Alle ongelezen/nieuwe documenten zijn vetgedrukt. U kunt deze filteren (u ziet dan alleen de ongelezen/nieuwe documenten) door het schuifje ‘Toon alleen ongelezen’ aan te zetten\n{imageOne}\nDocumenten bijv. Orders die al gezien zijn kunt u uiteraard ook weer markeren als ongelezen. Dit kunt u doen door te gaan naar het scherm Orders. U ziet hier nu de ongelezen en gelezen Orders. Als u een order wilt markeren als ongelezen (de Order wordt dan weer vetgedrukt) dan klikt u de betreffende order aan door een vinkje te zetten in de kolom ervoor.\n{imageTwo}\nDaarna klikt u in het scherm ‘Maak een keuze’ u kunt hier kiezen tussen: {list}`,
  SUPPORT_ANSWER_TERMINATE_ACCESS:
    "U kunt de wijziging doen via “Gebruikersbeheer” door rechtsboven op uw inlognaam te klikken. Daarna klikt u in het drop down menu op “Gebruikersbeheer”. U ziet hier dan alle huidige gebruikers. U kunt hier de gebruiker verwijderen of de toegang wijzigen.",
  SUPPORT_QUESTION_ACCESS:
    "Ik wil iemand anders van het bedrijf toegang geven tot mijn gegevens. Kan dat?",
  SUPPORT_QUESTION_ADDRESS: "Kan ik zelf iets wijzigen in Mijn CNB?",
  SUPPORT_QUESTION_ALL_DELIVERIES:
    "Ik wil dat de partijgegevens van alle leveringsnota’s die ik maak standaard naar het ketenregister worden gestuurd?",
  SUPPORT_QUESTION_ARRIVED:
    "Hoe weet ik zeker dat mijn gegevens zijn aangekomen bij het ketenregister?",
  SUPPORT_QUESTION_BATCH_DATA:
    "Wat doet het ketenregister met mijn partijgegevens?",
  SUPPORT_QUESTION_CHAIN_REGISTER: "Wat is het ketenregister?",
  SUPPORT_QUESTION_CHANGE_PASSWORD:
    "Hoe vaak moet ik mijn wachtwoord wijzigingen?",
  SUPPORT_QUESTION_CNB:
    "Als ik mijn partijgegevens meld aan het ketenregister via Mijn CNB  moet ik dan mijn leveringen apart aan CNB melden?",
  SUPPORT_QUESTION_CORRECTION:
    "Kan ik correcties in de partijgegevens melden aan het ketenregister?",
  SUPPORT_QUESTION_DELIVERIES: "Waar kan ik een levering invoeren?",
  SUPPORT_QUESTION_DONT:
    "Ik wil niet dat de partijgegevens van de leveringsnota aan het ketenregister worden gemeld?",
  SUPPORT_QUESTION_GROWER:
    "Hoe voer ik een levering van een kwekersvereniging in?",
  SUPPORT_QUESTION_ORDERS: "Waar vind ik de koopovereenkomsten of orders?",
  SUPPORT_QUESTION_OTHER:
    "Kan ik via Mijn CNB ook partijgegevens van koopovereenkomsten/orders van andere IVB’s aan het ketenregister melden?",
  SUPPORT_QUESTION_PASSWORD: "Hoe moet ik mijn wachtwoord wijzigen?",
  SUPPORT_QUESTION_REPORT:
    "Wanneer moet ik mijn partijgegevens melden aan het ketenregister?",
  SUPPORT_QUESTION_SEEN: "Wat gebeurt er als ik een document op ‘gezien’ zet?",
  SUPPORT_QUESTION_TERMINATE_ACCESS:
    "Iemand heeft toegang tot mijn gegevens en ik wil dat stop zetten?",
  SUPPORT_TITLE_ADDRESS: "NAW (Naam-Adres-Woonplaats)",
  SUPPORT_TITLE_DELIVERIES: "Leveringen",
  SUPPORT_TITLE_DOCUMENT: "Nieuwe Documenten",
  SUPPORT_TITLE_LOGIN: "Inloggen:",
  SUPPORT_TITLE_ORDERS: "Orders",
  SUPPORT_TITLE_SEARCH:
    "Hoe kan ik van een koopovereenkomst of order alle facturen inzien, printen en opslaan?",
  SURFACE: "Surface",
  SURE: "Are you sure?",
  TEXT: "Text",
  TEXT_EN: "Text EN",
  TEXT_NL: "Text NL",
  TEXT_TEASER: "Text teaser",
  TEXT_TEASER_EN: "Text teaser EN",
  TEXT_TEASER_NL: "Text teaser NL",
  TIME: "Time",
  TITLE: "Title",
  TITLE_EN: "Title EN",
  TITLE_NL: "Title NL",
  TO: "to",
  TOTAL: "Total",
  TOTAL_DEDUCTIONS: "Total deductions / blockages",
  TOTAL_GREATER_ZERO: "# Total must be greater than 0",
  TOTAL_INVOICE_AMOUNT: "Total invoice amount",
  TRANSPORT: "Transport",
  TULIP: "Tulip",
  TYPE: "Type",
  TYPE_BULB: "Eg. bulb crops",
  TYPE_GENERAL: "General",
  TYPE_LILIES: "Lelies",
  TYPE_TULIP: "Tulip",
  UNIT: "Unit",
  UNDER_CONTRACT_BULB:
    "If your bulbs are grown under contract, please mention the name and mobile phone number of the contractor :",
  UPLOAD_EXTENSION_ERROR: "Only the following file extensions are available:",
  UPLOAD_SIZE_ERROR: "The uploaded file must be less than 2 MB",
  CUSTOMER_COMPLAINTS: "Customer Complaints",
  USER_MANUALS: "User manuals",
  USER_MANUALS_DELIVERIES_TITLE:
    "Mijn CNB gebruikershandleiding Invoeren leveringen",
  USER_MANUALS_DELIVERIES_DESCRIPTION: "Handleiding invoeren leveringen",
  USER_MANUALS_STATEMENTS_TITLE:
    "Mijn CNB gebruikershandleiding Rekeningoverzicht en BTW en omzetoverzicht per betaaldatum",
  USER_MANUALS_STATEMENTS_DESCRIPTION:
    "Handleiding Rekening en betaaldatumovericht",
  USER_MANUALS_EXCEL_TITLE:
    "Mijn CNB gebruikershandleiding Rekeningoverzicht naar Excel exporteren",
  USER_MANUALS_EXCEL_DESCRIPTION: "Handleiding Rekening naar Excel exporteren",
  USER_MANUALS_RESET_PASSWORD_TITLE:
    "Mijn CNB gebruikershandleiding Wachtwoord resetten",
  USER_MANUALS_RESET_PASSWORD_DESCRIPTION: "Handleiding wachtwoord resetten",
  USER_MANUALS_ZURRNOTA_TITLE: "My CNB Zuurnota user manual",
  USER_MANUALS_ZURRNOTA_DESCRIPTION:
    "Mijn CNB gebruikershandleiding Zuurnota invoeren",
  USERS: "User management",
  VALIDATION_EMAIL: "E-mail is not valid",
  VALIDATION_MORE_THAN_START: "This field can not be more than",
  VALIDATION_MORE_THAN_END: "characters",
  VALIDATION_MORE_THAN_ONE: "Must be more than 1",
  VALIDATION_MORE_THAN_ZERO: "Must be more than 0",
  VALIDATION_MUST_CONTAIN_START: "This field must contain",
  VALIDATION_MUST_CONTAIN_END: "characters",
  VALIDATION_ONLY_POSITIVE: "Only positive numbers are allowed",
  VALIDATION_ONLY_NUMBERS: "Only numbers are allowed",
  VALIDATION_REQUIRED: "Required",
  VAT_RATE: "Gross VAT rate",
  VAT_STATUS: "VAT status",
  VERSION: "Version",
  VERSION_NR: "Version nr.",
  VERSIONS: "Versions",
  VIEW_PDF: "View PDF document",
  VISIBLE: "Visible",
  WEBSITE: "CNB Website",
  WELCOME: "Welcome",
  X_COORDINATE: "X-coordinate",
  YES: "Yes",
  Y_COORDINATE: "Y-coordinate",
  ADDRESS: "ADDRESS",
  PLACE: "PLACE",
  AGREEMENT_NUMBER: "AGREEMENT NUMBER",
  AGREEMENT_NUMBER_SUBJECT: "Subject: CNB agreement number",
  QUANTITY_RECEIVED: "QUANTITY RECEIVED",
  NUMBER_OF_BULBS: "NUMBER OF BULBS",
  SPECIES_CULTIVAR: "Species (Cultivar)",
  MATE: "MATE",
  RELATIONSHIP_NO: "RELATIONSHIP NO",
  CUSTOMER_COMPLAINT_NOTIFICATION:
    "Remember to notify the seller? The form will not be sent to them.",
  BULBS_ARE_AVAILABLE: "The Bulbs are available",
  NO_OF_SPHERES: "The number of sour spheres is determined by sampling",
  ORBS_ARE_DESTROYED: "The orbs are/are destroyed",
  OTHER_VIZ: "OTHERS, VIZ",
  COMPLETE_BUYER_INFORMATION: "Complete buyer information below:",
  CHECK_AND_COMPLETE_BELOW_AS: "Please tick/fill in below as applicable:",
  MAKE_COMPLAINT: "ENTER ACID BILL",
  THE_UNDESIGNED_DECLARES_THE_NUMBER_OF_SOUR_BULBS:
    "I hereby declare the number of sour bulbs found in the following batch(es)",
  COMPLAINT_AGREEMENT_LABEL:
    "I hereby declare that I have completed this form truthfully",
  INVALID_PRICE_FORMAT: "Invalid price format",
  INVALID_PRICE_MESSAGE: 'Geaccepteerd formaat: "123,45" of "123"',
};
